export default "__VITE_ASSET__940343e3__"